export const VOID_UNSUPPORTED_ENTITY_GROUP_CATEGORIES = ['Region'];
